import { render, staticRenderFns } from "./customer_address_list.vue?vue&type=template&id=6a9da34d&scoped=true"
import script from "./customer_address_list.vue?vue&type=script&lang=js"
export * from "./customer_address_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9da34d",
  null
  
)

export default component.exports